import uberDelivery from "../index";
import params from "../../../setup/config/params";

const routes = {
  uberDelivery: {
    path: (orderId = ":orderId") => `/uberDelivery/${orderId}`,
    component: uberDelivery,
    auth: true,
    role: [params.user.roles.admin.key, params.user.roles.vendor.key],
    module: "orders",
    subModule: "orderHistory",
    action: "canView"
  },
};

export default routes;
